<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="visible">        
        <div class="welcone-modal u-window">           
            <div class="dialog-content">
                <div class="u-btn close" @click="closeModal"></div>
                <div class="dialog-wrapper">
                    <div class="title"></div>
                    <div class="ticket-view">
                        <ul v-if="shop_list.length > 0" class="ticket-list">
                            <li class="ticket-item" v-for="(item,index) in shop_list" :key="index">
                                <div class="status apply" v-if="item.state == 1"></div>
                                <div class="status dismiss" v-if="item.state == 2"></div>
                                <div class="t-title">
                                    <div class="type" v-if="item.type == 1">{{ item.value }}</div>
                                    <div class="type" v-if="item.type == 2">{{ item.value }}折</div>
                                    <div class="slogen">{{ item.slogen }}</div>
                                </div>

                                <div class="t-detail">
                                    <h5 v-if="item.type == 1">店铺满减券</h5>
                                    <h5 v-if="item.type == 2">店铺折扣券</h5>
                                    <div class="content"><span v-if="item.full > 0">满{{ item.full }}可用，</span>最多可抵扣{{ item.maxAmt }}</div>
                                    <div class="time">{{ $global.activityTime }}</div>
                                </div>
                            </li>
                        </ul>  
                    </div>

                    <div class="msg-view">
                        <p v-if="history_apply == 0">阿斗新增积分兑换商城啦！</br>帮人砍价得积分，免费兑换豪华奖励！</p>
                        <p v-if="history_apply <= 3 && history_apply > 0">新增积分兑换系统，</br>参与阿斗期数越多，可兑换奖励越丰厚！</p>
                        <p v-if="history_apply> 3">阿斗回馈礼上新，</br>消费还可得积分兑换奖励，尽情体验吧~</p>
                    </div>

                    <div class="u-ctrl">
                        <div class="u-btn ok" @click="closeModal"></div>
                    </div>
                </div>
            </div>            
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>       
</template>

<style lang="scss" scoped>
.welcone-modal{
    position: relative;
    width: 625px;
    height: 445px;
    font-size: 24px;
    color: #3d3e43;
    background-image: url(~@/assets/images/modal/bg-modal-welcome.png);
}

.title{
    width: 516px;
    height: 52px;
    margin: 0 auto 15px;
    background-image: url(~@/assets/images/modal/title-welcome.png);    
}

.ticket-list{
    .ticket-item{
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 531px;
        height: 136px;
        margin: 0 auto 10px;
        padding: 0 20px 0 45px;
        background-image: url(~@/assets/images/modal/bg-ticket.png);

        .t-title{
            width: 134px;
            text-align: center;
        }

        .type{
            font-size: 60px;
            font-weight: 700;
            color: #b23700;
        }

        .slogen{
            color: #b23700;
        }

        .t-detail{
            width: 340px;
            color: #864b31;
            text-align: center;
            margin-left: 30px;

            h5{
                font-size: 24px;
                margin-bottom: 12px;
            }

            .content{
                font-size: 20px;
            }

            .time{
                font-size: 20px;
            }
        }
    }
}

.msg-view{
    text-align: center;
    /* width: 666px;
    height: 137px;
    margin: 20px auto;
    background-image: url(~@/assets/images/bg-msg.png);
    color: #8e492e; */
}

.msg-view p{
    padding: 0 36px;
    margin-bottom: 15px;
    color: #696560;
}

.msg-view b{
    color: #fe5a1e;
}

.u-ctrl{
    position: absolute;
    left: 50%;
    bottom: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    transform: translateX(-50%);
}

.u-ctrl .u-btn.ok{
    width: 186px;
    height: 56px;
    background-image: url(~@/assets/images/modal/btn-read.png);    
}


</style>

<script>
export default {
    data () {
        return {
            visible : false,
            text : '',
            shop_list : [],
            history_apply : 0,
        }
    },
    watch: {
        closed (newVal) {
            if (newVal) {
                this.visible = false
                this.destroyElement()
            }
        }
    },
    created (){
        document.body.style.overflow = 'hidden';
        localStorage.setItem('first', 1);

        this.render();
    },
    methods : {
        destroyElement () {
            document.body.style.overflow = ''; // 出现滚动条
            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },        
        closeModal(){
            this.destroyElement()
        },
        render (){
            this.$get(ajax_url_map.task_info,{
                success : (data) => {
                    this.history_apply = data.data.terms;
                }
            })
        },               
    },    
}
</script>